import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n      &:hover {\n        & ", " svg {\n          fill: ", ";\n        }\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  &:active {\n    & ", " svg {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { IconDefault } from '../../SvgIcon';
import { LinkBase, Small } from '../../Typography';
import { ICON_SMALL_SIZE, INFO_WITH_ICONS_TINY_MARGIN } from '../../constants';
import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED } from '../../colors';
import InfoWithIconsSimple from '../InfoWithIcons/InfoWithIconsSimple';
import ChevronForwardIcon from '@tourlane/iconography/Glyphs/Navigation/ChevronForward';
import ChevronChevronBack from '@tourlane/iconography/Glyphs/Navigation/ChevronBack';
import { useDeviceType } from '../../hooks';
var WRAPPER_STYLE = {
  display: 'inline-block'
};
var StyledIconDefault = styled(IconDefault)(_templateObject());
var StyledLinkBase = styled(LinkBase)(_templateObject2(), function (_ref) {
  var $hasTouch = _ref.$hasTouch;
  return !$hasTouch && css(_templateObject3(), StyledIconDefault, ADVENTURE_GREEN);
}, StyledIconDefault, ADVENTURE_GREEN_FOCUSED);

var _ref3 = /*#__PURE__*/React.createElement(StyledIconDefault, {
  icon: /*#__PURE__*/React.createElement(ChevronChevronBack, null)
});

var _ref4 = /*#__PURE__*/React.createElement(StyledIconDefault, {
  icon: /*#__PURE__*/React.createElement(ChevronForwardIcon, null)
});

var InfoLink = /*#__PURE__*/React.forwardRef(function (_ref2, forwardedRef) {
  var forwardedAs = _ref2.forwardedAs,
      as = _ref2.as,
      _ref2$component = _ref2.component,
      Component = _ref2$component === void 0 ? Small : _ref2$component,
      icon = _ref2.icon,
      iconRight = _ref2.iconRight,
      arrow = _ref2.arrow,
      children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, ["forwardedAs", "as", "component", "icon", "iconRight", "arrow", "children"]);

  var _useDeviceType = useDeviceType(),
      hasTouchScreen = _useDeviceType.hasTouchScreen;

  var iconProps = icon ? {
    icon: /*#__PURE__*/React.createElement(StyledIconDefault, {
      icon: icon,
      size: ICON_SMALL_SIZE
    }),
    iconMargin: INFO_WITH_ICONS_TINY_MARGIN
  } : arrow === 'left' ? {
    iconTopPosition: {
      xs: 1,
      xl: 0
    },
    icon: _ref3,
    iconMargin: INFO_WITH_ICONS_TINY_MARGIN
  } : {};
  var iconRightProps = iconRight ? {
    iconRight: /*#__PURE__*/React.createElement(StyledIconDefault, {
      icon: iconRight,
      size: ICON_SMALL_SIZE
    }),
    iconRightMargin: INFO_WITH_ICONS_TINY_MARGIN
  } : arrow === 'right' ? {
    iconRightTopPosition: {
      xs: 1,
      xl: 0
    },
    iconRight: _ref4,
    iconRightMargin: INFO_WITH_ICONS_TINY_MARGIN
  } : {};
  return (
    /*#__PURE__*/
    // @ts-expect-error Special type
    React.createElement(Component, _extends({
      ref: forwardedRef,
      as: 'span',
      style: WRAPPER_STYLE
    }, props), /*#__PURE__*/React.createElement(StyledLinkBase, {
      forwardedAs: forwardedAs != null ? forwardedAs : as,
      $hasTouch: hasTouchScreen,
      variant: "primary",
      userSelectNone: true,
      block: true,
      strong: true
    }, /*#__PURE__*/React.createElement(InfoWithIconsSimple, _extends({
      component: Component
    }, iconProps, iconRightProps), children)))
  );
});
export default InfoLink;